<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">确认信息</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="user-info" v-if="!showInvalidQr">
            <img class="invalid-user-img" :src="userAvatar ? userAvatar : defaultImg">
            <div class="user-name">{{userName}}</div>
        </div>
        <div class="invalid" v-if="showInvalidQr">
            <img class="invalid-img" src="@/assets/share/qrResult/invalid.png">
            <div class="invalid-text">无效二维码</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'qrResult',
        data() {
            return {
                showInvalidQr: true,
                userName: '',
                userAvatar: ''
            }
        },
        mounted() {
            this.result = this.$route.params.result;
            if (this.result == localStorage.getItem("userId")){
                this.showInvalidQr = false;
                this.userName = localStorage.getItem("userName");
                this.userAvatar = localStorage.getItem("userAvatar");
            } else {
                this.showInvalidQr = true;
            }
        },
        methods: {
            back() {
                this.$router.back();
            },
        }
    }
</script>

<style scoped>

    .user-info {
        text-align: center;
        position: relative;
    }

    .invalid-user-img {
        width: 50px;
        height: 50px;
        border: 1px solid #707070;
        margin-top: 20px;
        border-radius: 50%;
        position: absolute;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .user-name {
        font-size: 15px;
        padding-top: 82px;
        color: #ffffff;
        opacity: 0.9;
    }

    .invalid {
        text-align: center;
    }

    .invalid-img {
        width: 166px;
    }

    .invalid-text {
        font-size: 15px;
        text-align: center;
        margin-top: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/qrResult.vue